import Vue from "vue";
import { AuthStore, authStore } from "./auth";
import { DeploymentStore, deploymentStore } from "./deployment";
import { MobileStore, mobileStore } from "./mobile";
import { OfflineStore, offlineStore } from "./offline";
import { ProtectionStore, protectionStore } from "./protection";
import { SidebarStore, sidebarStore } from "./sidebar";
import { plantStore, PlantStore } from "./plant";

export interface Store {
  readonly mobile: MobileStore;
  readonly offline: OfflineStore;
  readonly protection: ProtectionStore;
  readonly sidebar: SidebarStore;
  readonly auth: AuthStore;
  readonly plant: PlantStore;
  readonly deployment: DeploymentStore;
}

export const store: Store = Vue.observable({
  mobile: mobileStore,
  offline: offlineStore,
  protection: protectionStore,
  sidebar: sidebarStore,
  auth: authStore,
  plant: plantStore,
  deployment: deploymentStore,
});